import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SectionHeading } from '../ui/Panels';
import { StarRow } from '../ui/Rating';
import { reviews } from '../../data/reviews';
import { chefById } from '../../data/chefs';
import { dateWithYear } from '../../utils/format';
import { riseItem, staggerContainer, viewportOnce } from '../../utils/motion';
export function Voices() {
  const reduce = useReducedMotion();
  const [feature, ...supporting] = [reviews[0], reviews[7], reviews[4]];
  return <section aria-labelledby="voices-heading" className="mx-auto max-w-shell px-5 pb-20 lg:px-8 lg:pb-24" data-id="element-762" data-mp="3fc6mlowa9no8">
      <SectionHeading level={2} title="What guests said afterwards" hint="Every review scores four things separately." data-id="element-763" data-mp="31l1ioalvu983" />

      <motion.div variants={staggerContainer(0.07)} initial="hidden" whileInView="show" viewport={viewportOnce} className="mt-9 grid gap-5 lg:grid-cols-[1.25fr_1fr]" data-id="element-764" data-mp="36j36t9y60yqf">
        <motion.figure variants={riseItem(reduce, 20)} className="flex flex-col rounded-2xl border border-hairline bg-surface p-6 lg:p-8" data-id="element-765" data-mp="2wmhwc93dmvf7">
          <blockquote className="font-display text-xl leading-snug tracking-[-0.01em] text-ink lg:text-2xl" data-id="element-766" data-mp="29yeuwb5e9po9">
            “{feature.body}”
          </blockquote>
          <figcaption className="mt-6 flex flex-wrap items-end justify-between gap-6 border-t border-hairline pt-5" data-id="element-767" data-mp="2nv21z6r29w7w">
            <div data-id="element-768" data-mp="1w5yyht700pwb">
              <p className="text-sm font-semibold text-ink" data-id="element-769" data-mp="1w5fk2mgk4jn1">{feature.author}</p>
              <p className="text-[13px] text-ink-2" data-id="element-770" data-mp="1r7dvxn49xu4p">
                {feature.occasion} · {chefById(feature.chefId)?.name}
              </p>
              <p className="mt-0.5 text-[12px] text-ink-3" data-id="element-771" data-mp="2503lu2mxbj73">{dateWithYear(feature.date)}</p>
            </div>
            <div className="space-y-1.5" data-id="element-772" data-mp="20692j0b8d68j">
              <StarRow value={feature.scores.food} label="Food" data-id="element-773" data-mp="1chzo4jgcjkrf" />
              <StarRow value={feature.scores.cleanliness} label="Cleanliness" data-id="element-774" data-mp="1cg5211tc9mlr" />
            </div>
          </figcaption>
        </motion.figure>

        <div className="grid gap-5" data-id="element-775" data-mp="37lxr044dfqvu">
          {supporting.map(review => <motion.figure key={review.id} variants={riseItem(reduce, 20)} className="flex flex-col rounded-2xl border border-hairline bg-surface p-5" data-id="element-776" data-mp="3ckhazyzemslk">
              <blockquote className="text-[15px] leading-relaxed text-ink-2" data-id="element-777" data-mp="3ma0v17yussi0">“{review.body}”</blockquote>
              <figcaption className="mt-4 border-t border-hairline pt-3 text-[13px]" data-id="element-778" data-mp="2on1w0qkov8gy">
                <span className="font-semibold text-ink" data-id="element-779" data-mp="2tlmuakgdri2r">{review.author}</span>
                <span className="text-ink-2" data-id="element-780" data-mp="2tnpo7fknlvcr"> · {review.occasion}</span>
              </figcaption>
            </motion.figure>)}
        </div>
      </motion.div>
    </section>;
}